import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { INK } from "../../theme/tokens";

type CensusChangesWarningDialogProps = {
	open: boolean;
	newCensus: number | undefined;
	onCancel: () => void;
	onConfirm: () => void;
};

export const CensusChangesWarningDialog: FC<CensusChangesWarningDialogProps> = ({ open, onCancel, onConfirm, newCensus }) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth data-testid="census-warning-dialog">
			<DialogTitle sx={{ color: INK.SECONDARY, fontWeight: 600 }}>{t("draft.mode.census.warning.title")}</DialogTitle>
			<DialogContent>
				<DialogContentText sx={(theme) => ({ color: theme.palette.primary.light })}>{t("draft.mode.census.warning.message", { newCensus })}</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
				<Button onClick={onCancel} color="inherit" variant="outlined" data-testid="census-warning-cancel-button">
					{t("restore.census")}
				</Button>
				<Button onClick={onConfirm} color="primary" variant="contained" data-testid="census-warning-confirm-button">
					{t("draft.mode.census.confirm.publish")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
